import gql from 'graphql-tag'

export const FullGeneralTranslationFragment = gql`
  fragment FullGeneralTranslation on GeneralTranslation {
    slug
    translation
  }
`

export default gql`
  query GeneralTranslation($lang: [Locale!]!, $stage: Stage!) {
    generalTranslations(locales: $lang stage: $stage) {
      ...FullGeneralTranslation
    }
  }
  ${FullGeneralTranslationFragment}
`



// WEBPACK FOOTER //
// ./src/queries/generalTranslations.js